import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithResilience } from "./baseQuery";

// Token selection (including the D15 customer-portal fix), timeout,
// error classification, global 401 handling, and retry all live in
// baseQuery.js now - shared with exportApiSlice.js so neither api instance
// can drift out of sync with the other on error handling.

// API Slice Definition
export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithResilience,
  tagTypes: [
    "User",
    "Market",
    "Subscription",
    "Company",
    "Customer",
    "billingunit",
    "Roles",
    "Permissions",
    "Teams",
    "CurrentUserPermissions",
    "DocumentTemplate",
    "DocumentTemplateVersions",
    "PlatformEvents",
    "PlatformSettings",
    "Upsells",
    "Contacts",
    "ObjectCustomizations",
    "Webhooks",
    "ApiKeys",
    "Migrations",
    "MigrationEntities",
    "CompanyStats",
    "RevenueCmrr",
    "PlanStats",
    "Sandboxes",
    "SandboxEvents",
    "SandboxWallets",
    "Snapshots",
    "Predictions",
    "Bundles",
    "Scenarios",
    "ScenarioRuns",
  ],
  endpoints: (builder) => ({}),
});
